import type { DownloadButtonLabelProps, ResolvedDownloadButtonLabels } from './types'

export const downloadButtonResourceSet = 'download'

export const defaultDownloadButtonLabels = {
  primaryLabel: 'Download EVE Online',
  downloadWindowsLabel: 'Download EVE Windows Client',
  downloadMacLabel: 'Download EVE Mac Client',
} as const satisfies Pick<DownloadButtonLabelProps, 'primaryLabel' | 'downloadWindowsLabel' | 'downloadMacLabel'>

export const downloadButtonResourceKeys = {
  primaryLabel: 'download.label',
  downloadWindowsLabel: 'download.windows.label',
  downloadMacLabel: 'download.mac.label',
} as const

type DownloadButtonResourceKey = (typeof downloadButtonResourceKeys)[keyof typeof downloadButtonResourceKeys]

type DownloadButtonResourceMessages = Partial<Record<DownloadButtonResourceKey, string>>

export function resolveDownloadButtonLabels(messages?: Record<string, string> | null): ResolvedDownloadButtonLabels {
  const typedMessages = messages as DownloadButtonResourceMessages | undefined

  return {
    primaryLabel: typedMessages?.[downloadButtonResourceKeys.primaryLabel] ?? defaultDownloadButtonLabels.primaryLabel,
    downloadWindowsLabel:
      typedMessages?.[downloadButtonResourceKeys.downloadWindowsLabel] ??
      defaultDownloadButtonLabels.downloadWindowsLabel,
    downloadMacLabel:
      typedMessages?.[downloadButtonResourceKeys.downloadMacLabel] ?? defaultDownloadButtonLabels.downloadMacLabel,
  }
}
